module.exports = __webpack_public_path__ + "img/Photo-Theodora_Ntanasi.3f525882.jpg";